import en from './en.json'
import it from './it.json'

export const acceptInviteTranslations = {
	en,
	it
} as const
